fragment CalcuraFieldFragment on CalcuraField {

    id

    name
    label
    short_label

    description

    mode
    type

    check_errors

    required

    required_error_message

    hide_field_product_page
    hide_field_cart_if_empty
    hide_field_checkout_if_empty
    hide_field_cart
    hide_field_checkout
    hide_field_order

    text_after_field

    list_type

    list_show_radio_button

    checkbox_checked_value
    checkbox_unchecked_value
    checkbox_default_status

    numeric_default_value

    numeric_max_value
    numeric_max_value_error

    numeric_min_value
    numeric_min_value_error

    numeric_decimals

    numeric_decimal_separator
    numeric_thousands_separator

    numeric_slider_enabled

    date_format
    date_default_value

    time_format
    time_default_value

    datetime_format
    datetime_default_value

    text_default_value
    text_regex
    text_regex_error

    listItems {
        ...CalcuraFieldListItemFragment
    }

    listCategories {
        ...CalcuraFieldListCategoryFragment
    }

}